import { render, staticRenderFns } from "./CheckoutAddresses.vue?vue&type=template&id=8d5ab264&"
import script from "./CheckoutAddresses.vue?vue&type=script&lang=js&"
export * from "./CheckoutAddresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports